<script lang="ts">
	import Layout from "../components/Layout.svelte";
	import References from "../components/References/References.svelte";
	import Contact from "../components/Contact.svelte";
	import type { HelpPageProps } from "./HelpPageProps.js";
	import HelpSection from "../components/HelpSection.svelte";

	type $$Props = HelpPageProps;

	const { references } = $$restProps as $$Props;
</script>

<Layout>
	<div class="container mt-16 flex flex-col">
		<HelpSection startLazyLoadingOnIndex={4} topLevel />
		<References {references} />
		<div class="mt-28 lg:mt-0">
			<Contact />
		</div>
	</div>
</Layout>
